import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { Website } from "@/api/types"

interface CompanyVisitsResponse {
	visits: number | null
}

export function companyVisitsOptions(
	website: Website,
	companyId: string | undefined,
) {
	return queryOptions({
		queryKey: ["analytics", website, "companies", companyId, "visits"],
		queryFn: () =>
			GET("/api/v1/analytics/{website}/companies/{company_id}/visits", {
				params: { path: { website, company_id: companyId! } },
			}) as Promise<CompanyVisitsResponse>,
		enabled: !!companyId,
	})
}

export function useCompanyVisits(
	website: Website,
	companyId: string | undefined,
	enabled = true,
) {
	return useQuery({
		...companyVisitsOptions(website, companyId),
		enabled: enabled && !!companyId,
	})
}
